import { ASTheme, useASTheme } from '@eleventheye/asui';

/**
 * Preserve the existing appTheme hook API while following the nearest provider.
 * @return {{ appTheme: ASTheme }} The inherited project theme.
 */
export const useTheme = (): { appTheme: ASTheme } => {
  const appTheme = useASTheme();
  return { appTheme };
};

export default useTheme;
